import { List, Set, fromJS } from "immutable";

const equipmentAndParts = fromJS({
  Conveyors: [
    "End Bearings",
    "Hanger Bearings",
    "Screws",
    "Conveyor Belts",
    "Conveyor Rollers",
  ],
  Pumps: ["Bearings", "Shafts", "Impellers", "Mechanical Seals", "Packings"],
  Fans: ["Bearings", "Impellers", "Couplings", "V-Belts", "Shafts"],
  Blowers: ["Bearings", "Belts", "Sheaves", "Couplings", "Rotary Lobes"],
  Agitators: ["Gearboxes", "Bearings", "Belts", "Impellers"],
  Centrifuges: ["Bearings", "Couplings", "Belts", "Sheaves", "Baskets"],
  Heaters: ["Inlet Piping", "Outlet Piping", "Tubes", "Valves", "Tube Sheets"],
  Boilers: [
    "Wall Tubes",
    "Generating Tubes",
    "Screen Tubes",
    "Superheater Drums",
    "Mud Drums",
    "Burners",
    "Nozzels",
  ],
  Engines: [
    "Pistons",
    "Rocker Arms",
    "Connecting Rods",
    "Connecting Rod Bearings",
    "Main Bearings",
    "Crank Shafts",
    "Valves",
    "Fuel Lines",
    "Gears",
  ],
  Valves: ["Valve Handles", "Valve Stems", "Balls", "Knives"],
  Dryers: [
    "Bearings",
    "Gears",
    "Trunnions",
    "Chains",
    "Sprockets",
    "V-Belts",
    "Sheaves",
  ],
});

export const allEquipment = Set(equipmentAndParts.keySeq());

export const allParts = Set(equipmentAndParts.valueSeq().flatten());

export const equipmentToParts = e => Set(equipmentAndParts.get(e, List()));
